export default __webpack_public_path__ + "static/media/P310 zu P311.f01509d4.mp3";